import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CompanyGroup } from '../../../../models/CompanyGroup.model';
import { CompanyGroupSearch } from '../../../../models/CompanyGroupSearch.model';
import { DropDownList } from '../../../../models/DropDownList.model';
import { CompaniesService } from '../../../../services/companies.service';
import { CompanyService } from '../../../../services/billing-letter/company.service';
import { ProjectFinancialService } from '../../../../services/projectFinancial.service';
import { CommonHelper } from '../../../../shared/helpers/CommonHelper';
import { Company } from "../../../../models/Company.model";
import { ExcellenceCenter } from "../../../../models/ExcellenceCenter.model";
import { Toast, ToastsManager } from "ng2-toastr";
import { Industry } from "../../../../models/Industry.model";
import { ExcellenceCentersService } from "../../../../services/excellenceCenters.service";
import { IndustriesService } from "../../../../services/industries.service";
import { CompanyInventoryModel, FinesAndInterest, InventoryContractType, ProjectHashtrack } from "../../../../models/CompanyInventory.model";
import { AwsService } from "../../../../services/aws.service";
import { UserService } from "../../../../services/user.service";
import { Responsible } from "../../../../models/Responsible.model";
import * as _ from 'lodash';
import * as moment from 'moment'
import { ErrorHandlerProvider } from "../../../../shared/providers/errorHandler.provider";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { GUARDS } from '../../../../shared/auth/Roles'
import { LocalStorage } from "../../../../shared/wrappers/LocalStorage";
import { Router, ActivatedRoute } from "@angular/router";
import { CompanyInventoryService } from "../../../../services/companyInventory.service";
import { ContractTypesService } from "../../../../services/contractTypes.service";

type Dropdown = {
  dropDownList: Array<DropDownList>;
  selectedItems: Array<DropDownList>;
  dropDownSettings: {};
  commonHelper: CommonHelper;
};

@Component({
  selector: 'app-company-inventory-edit',
  templateUrl: './company-inventory.component-edit.html',
  styleUrls: ['./company-inventory.component-edit.scss'],
})
export class CompanyInventoryEditComponent implements OnInit {
  @ViewChild('customerMultiselect') customerMultiselect;
  @ViewChild('projectsMultiselect') projectsMultiselect;
  @ViewChild('companyGroupMultiselect') companyGroupMultiselect;
  @ViewChild('fileInput') fileInput: ElementRef;

  loading = false;
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  dateMask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  companies = new Array<Company>();
  projects: ProjectHashtrack[] = [];
  companyGroupSearchModel = new CompanyGroupSearch();
  dropDownCompanyGroups: Dropdown;
  dropDownCustomer: Dropdown;
  dropDownProjectHashtrack: Dropdown;
  companyInventory: CompanyInventoryModel = new CompanyInventoryModel();
  contractTypes: InventoryContractType[] = [];
  readjustmentQuoeficient: Array<number> = [];
  finesAndInterests: Array<number> = [];
  industries: Industry[] = new Array<Industry>();
  excellenceCenters: ExcellenceCenter[] = new Array<ExcellenceCenter>();
  responsibles: Responsible[] = [];
  fileList;
  selectedFiles: FileList;
  downloadUrl = '';
  isFormInvalid = false;
  companyInventoryForm: FormGroup;
  GUARDS = GUARDS;
  user: any;
  isUserJudiciary = false;
  isDisabled = false;

  constructor(
    public commonHelper: CommonHelper,
    private projectsFinancial: ProjectFinancialService,
    private companiesService: CompaniesService,
    private companyService: CompanyService,
    private toastr: ToastsManager,
    private industriesService: IndustriesService,
    private excellenceCentersService: ExcellenceCentersService,
    private awsService: AwsService,
    private userService: UserService,
    private errorHandler: ErrorHandlerProvider,
    private formBuilder: FormBuilder,
    private localStorage: LocalStorage,
    private router: Router,
    private route: ActivatedRoute,
    private companyInventoryService: CompanyInventoryService,
    private contractTypesService: ContractTypesService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.user = this.localStorage.retrieve("user");
    if (this.user.permission == GUARDS.JUDICIARY) {
        this.isUserJudiciary = true;
    }
    if (this.user.permission == GUARDS.MANAGER || this.user.permission == GUARDS.COMMERCIAL) {
      this.isDisabled = true;
    }
    let mappedValues = {}
    const getFormFields = this.getRequiredFormFields();
    getFormFields.forEach((field: string) => {
        mappedValues[field] = new FormControl(null);
    });
    this.companyInventoryForm = this.formBuilder.group(mappedValues);

    const id = this.route.snapshot.params['id'];
    if (id) {
        const inventory = await this.companyInventoryService.getById(id);
        this.companyInventory.populate(inventory);
    } else {
        this.router.navigateByUrl('/company-inventory');
        return;
    }

    if (this.companyInventory.dateEnd.indefinitePeriod) {
        this.companyInventoryForm.controls["dateEnd"].disable();
        this.companyInventoryForm.controls["readjustmentDate"].disable();
    } else if (!this.companyInventory.readjustmentDate.notApplicable) {
        this.companyInventoryForm.controls["readjustmentDate"].disable();
    }

    const companyGroupWithCustomer = await this.companyService.getCompanyGroupsWithCustomer();
    const projectsAndCustomers = await this.projectsFinancial.getProjectsAndCustomers();
    this.companies = projectsAndCustomers.customers;
    this.projects = projectsAndCustomers.projects;

    this.dropDownCompanyGroups =
      this.projectsFinancial.createPropertyObjDropDown(
        companyGroupWithCustomer.groups,
        true,
        'Grupos',
        'grupos'
      );
    this.dropDownCompanyGroups.dropDownSettings = this.commonHelper.getDropDownSettings(true, 'Grupos', false, 'Marcar todos os grupos', 'Desmarcar todos os grupos', true, null, '', false);
    this.dropDownCustomer = this.projectsFinancial.createPropertyObjDropDown(
      this.companies,
      true,
      'Cliente',
      'clientes',
      ['group'],
      'group'
    );
    this.dropDownCustomer.dropDownSettings = this.commonHelper.getDropDownSettings(true, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true, null, '', true);
    this.dropDownCustomer.dropDownList.forEach(
      ({ group }: any) =>
        (group = this.commonHelper.transcriptDivisionGroup(group))
    );
    this.dropDownProjectHashtrack =
      this.projectsFinancial.createPropertyObjDropDown(
        this.projects,
        true,
        'Projetos',
        'projetos'
      );
    this.dropDownProjectHashtrack.dropDownSettings = this.commonHelper.getDropDownSettings(true, 'Projetos', false, 'Marcar todos os projetos', 'Desmarcar todos os projetos', true, null, '', true);

    this.populateContractTypes();

    this.readjustmentQuoeficient = this.commonHelper.getAllReadjustmentQuoeficientGroups();
    this.finesAndInterests = this.commonHelper.getAllFinesAndInterests();

    if (!this.companyInventory.industry) {
        this.companyInventory.industry = new Industry();
    }
    if (!this.companyInventory.industryResponsible) {
        this.companyInventory.industryResponsible = new Responsible();
    }

    this.industries = await this.industriesService.getAll();
    const allCenters = await this.excellenceCentersService.getAll();
    this.excellenceCenters = allCenters.filter(ec => Number(ec.type) == 1);
    this.responsibles = await this.userService.getActiveUsers();
    await this.getS3Files();
    if(this.fileList.length > 0) {
        this.download(this.fileList[0].Key);
    }

    await this.buildCompanyGroupCustomerAndProjectSelectors();
    this.formatDates();
    this.loading = false;
    if (!this.isUserJudiciary) {
        this.companyInventoryForm.disable();
        this.dropDownCompanyGroups.dropDownSettings = {
            ...this.dropDownCompanyGroups.dropDownSettings,
            disabled: true
        }
        this.dropDownCustomer.dropDownSettings = {
          ...this.dropDownCustomer.dropDownSettings,
          disabled: true
        }
        this.dropDownProjectHashtrack.dropDownSettings = {
          ...this.dropDownProjectHashtrack.dropDownSettings,
          disabled: true
        }
    }
  }

  formatDates() {
    if (this.companyInventory.startDate) {
        this.companyInventory.startDate = moment(this.companyInventory.startDate).format('DD/MM/YYYY');
    }

    if (this.companyInventory.dateEnd && this.companyInventory.dateEnd.date) {
        this.companyInventory.dateEnd.date = moment(this.companyInventory.dateEnd.date).format('DD/MM/YYYY');
    }

    if (this.companyInventory.readjustmentDate && this.companyInventory.readjustmentDate.date) {
        this.companyInventory.readjustmentDate.date = moment(this.companyInventory.readjustmentDate.date).format('DD/MM/YYYY');
    }
  }

  async buildCompanyGroupCustomerAndProjectSelectors() {
    if (this.companyInventory.companyGroup && this.companyInventory.companyGroup._id) {
        this.dropDownCompanyGroups.selectedItems[0] = {
            id: this.companyInventory.companyGroup._id,
            itemName: this.companyInventory.companyGroup.name
        }
        this.dropDownCustomer.dropDownSettings = {
            ...this.dropDownCustomer.dropDownSettings,
            disabled: false
        }

        const companiesByGroupId = await this.companiesService.getCompaniesByGroupId(this.dropDownCompanyGroups.selectedItems[0].id);
        this.dropDownCustomer.dropDownList =
            this.commonHelper.getDropDownListItems(
            companiesByGroupId,
            '_id',
            'name'
         );
    }

    if (this.companyInventory.customer && this.companyInventory.customer._id) {
        this.dropDownCustomer.selectedItems[0] = {
            id: this.companyInventory.customer._id,
            itemName: this.companyInventory.customer.name
        }
        this.dropDownProjectHashtrack.dropDownSettings = {
            ...this.dropDownProjectHashtrack.dropDownSettings,
            disabled: false
        }

        this.dropDownProjectHashtrack.dropDownList = this.commonHelper.getDropDownListItems(this.projects
            .filter(project => project.companyId == this.dropDownCustomer.selectedItems[0].id), "_id", "name");
    }

    if (this.companyInventory.project && this.companyInventory.project._id) {
        this.dropDownProjectHashtrack.selectedItems[0] = {
            id: this.companyInventory.project._id,
            itemName: this.companyInventory.project.name
        }
    }
  }

  getRequiredFormFields() {
    return [
      'consultantRequestedObservation',
      'trademarkUsageClauseObservation',
      'interes',
      'penalty',
      'finesAndInterests',
      'readjustmentDate',
      'readjustmentIndex',
      'dateEnd',
      'startDate',
      'contractType',
      'companyInventoryIndustry',
      'companyInventoryExcellenceCenter',
    ];
  }

  async onChangeCompanyGroup(): Promise<void> {
    this.dropDownCustomer.selectedItems = null;
    this.dropDownProjectHashtrack.selectedItems = null;
    if (this.dropDownCompanyGroups.selectedItems && this.dropDownCompanyGroups.selectedItems.length > 0) {
      const companiesByGroupId = await this.companiesService.getCompaniesByGroupId(this.dropDownCompanyGroups.selectedItems[0].id);
      this.dropDownCustomer.dropDownList =
        this.commonHelper.getDropDownListItems(
          companiesByGroupId,
          '_id',
          'name',
          ['industry']
        );
        this.customerMultiselect.settings.disabled = false;
    } else {
      this.customerMultiselect.settings.disabled = true;
      this.projectsMultiselect.settings.disabled = true;
    }
  }

  onChangeCustomer(): void {
    if (this.dropDownCustomer.selectedItems && this.dropDownCustomer.selectedItems.length > 0) {
      this.dropDownProjectHashtrack.dropDownList = this.commonHelper
      .getDropDownListItems(this.projects
        .filter(project => project.companyId == this.dropDownCustomer.selectedItems[0].id), "_id", "name");
      if(this.dropDownCustomer.selectedItems && this.dropDownCustomer.selectedItems.length > 0 && this.dropDownCustomer.selectedItems[0].industry) {
        this.companyInventory.industry._id = this.dropDownCustomer.selectedItems[0].industry._id;
      }
      this.projectsMultiselect.settings.disabled = false;
    } else {
        this.projectsMultiselect.settings.disabled = true;
    }
  }

  async populateContractTypes(): Promise<void> {
    this.contractTypes = (await this.contractTypesService.getAll())
        .filter(contract => contract.active);
    this.companyInventory.contractType = this.contractTypes.find(({ _id }) => _id == this.companyInventory.contractType._id);
  }

  verifyDate(date: string, field: string, nested?: string): boolean {
    if (field.startsWith('dateEnd') && this.companyInventory.dateEnd.indefinitePeriod) {
        this.companyInventory.dateEnd.date = '';
        return;
    }

    if (field.startsWith('startDate') && this.companyInventory.startDate) {
        this.companyInventory.readjustmentDate.date = ''
    };

    if (field.startsWith('reajustmentDate') && !this.companyInventory.readjustmentDate.notApplicable) {
        this.companyInventory.readjustmentDate.date = '';
        return;
    }

    let errorMessage = [];
    if(!(new RegExp(this.datePattern).test(date))){
        if (field.startsWith('dateEnd') || field.startsWith('reajustmentDate')) {
            this.companyInventory[field][nested] = "";
            errorMessage.push(`Digite um padrão de data válida para o campo, ${this.transcriptDateFields(field, nested)}`);
            this.toastr.warning(`${errorMessage.join('<br/>')}`,"Data inválida!", { enableHTML: true});
            return true;
        }
        this.companyInventory[field] = "";
        errorMessage.push(`Digite um padrão de data válida para o campo, ${this.transcriptDateFields(field)}`);
        this.toastr.warning(`${errorMessage.join('<br/>')}`,"Data inválida!", { enableHTML: true});
        return true;
    }

    const isValidDate = moment(date, 'DD/MM/YYYY');
    if (!isValidDate.isValid()) {
        if (field.startsWith('dateEnd') || field.startsWith('reajustmentDate')) {
            this.companyInventory[field][nested] = "";
            errorMessage.push(`Valor inserido é inválido para o campo, ${this.transcriptDateFields(field, nested)}`);
            this.toastr.warning(`${errorMessage.join('<br/>')}`,"Data inválida!", { enableHTML: true});
            return true;
        }
        this.companyInventory[field] = "";
        errorMessage.push(`Valor inserido é inválido para o campo, ${this.transcriptDateFields(field)}`);
        this.toastr.warning(`${errorMessage.join('<br/>')}`,"Data inválida!", { enableHTML: true});
        return true;
    }
    return false;
  }

  validateContractDateRange(dateStart: string, dateEnd: string): Promise<Toast> {
    if(dateStart && dateEnd)
      if(new Date(this.convertDateStringToISO(dateStart)).getTime() >= new Date(this.convertDateStringToISO(dateEnd)).getTime()) {
        this.companyInventory.dateEnd.date = '';
        return this.toastr.warning("A data final do contrato deve ser maior que a data de início do contrato.");
      }
  }

  validateContractReajustmentDate(dateStart: string, dateEnd: string, dateReajustment: string): void{
    if (!this.companyInventory.readjustmentDate.notApplicable) {
        this.companyInventory.readjustmentDate.date = '';
        return;
    };

    if(dateStart && dateEnd && dateReajustment) {
        if (
            new Date(this.convertDateStringToISO(dateStart)).getTime() <= new Date(this.convertDateStringToISO(dateReajustment)).getTime() &&
            new Date(this.convertDateStringToISO(dateEnd)).getTime() >= new Date(this.convertDateStringToISO(dateReajustment)).getTime()
        ) {
            const insertedDate = moment(dateReajustment, "DD/MM/YYYY");
            if (insertedDate.isBefore()) {
                this.companyInventory["dateReajustment"].date = '';
                this.toastr.warning(`A data de reajuste não pode ser retroativa.`, 'Data Inválida');
                return;
            }
        } else {
            this.companyInventory.readjustmentDate.date = '';
            this.toastr.warning("A data de reajuste deve estar entre o início e fim do contrato.");
            return;
        }
    } else {
        this.companyInventory.readjustmentDate.date = '';
        this.toastr.warning("Verifique os campos de datas e insira corretamente.", "Data inválida!");
        return;
    }
  }

  convertDateStringToISO(date: string): string {
    return `${date.substring(3, 5)}/${date.substring(0, 2)}/${date.substring(6, 11)}`;
  }

  selectFile(event: any): void {
    if (event.target.files.length > 10) {
        this.toastr.warning(
            'Não é possível fazer upload com mais de 10 arquivos. Selecione os arquivos novamente.',
            'Atenção!'
        );
        return;
    };
    this.selectedFiles = event.target.files as FileList;
  }

  async getS3Files(): Promise<void>{
    this.fileList = await this.awsService.getFiles(`company-inventory/${this.companyInventory._id}`);
  };

  async deleteFile(name: string): Promise<void>{
    try {
        const fileName = name.split("/")[1];
        this.toastr.warning(`Realizando a exclusão do arquivo ${fileName}...`, 'Exclusão');
        await this.awsService.deleteFile(name);
        this.toastr.success(`Arquivo ${fileName} excluído com sucesso!`);
        await this.getS3Files();
    } catch (error) {
        this.errorHandler.interceptError(error, "Inventário")
    }
  }

  async upload(id: string): Promise<void> {
    try {
        let length = this.selectedFiles.length;
        const maxAllowedFiles = 10;
        const filesSum = this.fileList.length + this.selectedFiles.length;
        if (filesSum > maxAllowedFiles) {
            this.toastr.warning(
                `Não é possível fazer upload com mais de ${maxAllowedFiles} arquivos.`, "Atenção!"
            );
            return;
        }
        for(let i=0; i<length; i++){
            const file = this.selectedFiles.item(i);
            await this.awsService.uploadfile(file,`company-inventory/${id}`);
        }
        await this.getS3Files();
        this.selectedFiles = null;
    } catch (error) {
        this.errorHandler.interceptError(error, "Inventário");
    }
  }

  async download(name: string): Promise<void> {
    this.downloadUrl = await this.awsService.download(name);
  }

  onFinesAndInterestsChange() {
    switch(this.companyInventory.finesAndInterests) {
        case 1:
            this.companyInventory.penalty = 0;
            return;
        case 2:
            this.companyInventory.interes = 0;
            return;
        case 3:
            return;
        case 4:
            this.companyInventory.penalty = 0;
            this.companyInventory.interes = 0;
            return;
        default:
            this.companyInventory.penalty = 0;
            this.companyInventory.interes = 0;
            this.toastr.warning("Escolha um status para Juros e Multa.", "Atenção!");
            return;
    }
  }

  isDateFieldsInvalid(): boolean {
    if (!this.companyInventory.startDate) {
        this.companyInventory.startDate = '';
        this.toastr.warning("Preencha o campo de data de início do contrato.", "Atenção!");
        return true;
    }

    if (this.verifyDate(this.companyInventory.startDate, 'startDate')) {
        this.toastr.warning("Preencha o campo de data de início do contrato corretamente.", "Atenção!");
        return true;
    }

    if (!this.companyInventory.dateEnd.indefinitePeriod) {
        if (!this.companyInventory.dateEnd.date) {
            this.companyInventory.dateEnd.date = '';
            this.toastr.warning("Preencha o campo de data de fim do contrato.", "Atenção!");
            return true;
        }

        if (this.verifyDate(this.companyInventory.dateEnd.date, 'dateEnd')) {
            this.toastr.warning("Preencha o campo de data de fim do contrato corretamente.", "Atenção!");
            return true;
        }
    }

    if (this.companyInventory.readjustmentDate.notApplicable) {
        if (!this.companyInventory.readjustmentDate.date) {
            this.companyInventory.readjustmentDate.date = '';
            this.toastr.warning("Preencha o campo de data de reajuste.", "Atenção!");
            return true;
        }

        if (this.verifyDate(this.companyInventory.readjustmentDate.date, 'readjustmentDate')) {
            this.toastr.warning("Preencha o campo de data de reajuste do contrato corretamente.", "Atenção!");
            return true;
        }
    }
    return false;
  }

  transcriptDateFields(field: string, nested?: string): string {
    const dateFields = {
        startDate: 'Data de início',
        dateEnd: {
            date: 'Data de fim'
        },
        readjustmentDate: {
            date: 'Data de reajuste'
        }
    }
    return nested ? dateFields[field][nested] : dateFields[field];
  }

  isFinesAndInterestInvalid(): boolean {
    switch(this.companyInventory.finesAndInterests) {
        case 1:
            if (!this.companyInventory.interes) {
                this.toastr.warning("Digite o valor do juros.", "Atenção!");
                return true;
            }
            return;
        case 2:
            if (!this.companyInventory.penalty) {
                this.toastr.warning("Digite o valor da multa.", "Atenção!");
                return true;
            }
            return;
        case 3:
            if (!this.companyInventory.penalty || !this.companyInventory.interes) {
                this.toastr.warning("Digite o valor do juros e da multa.", "Atenção!");
                return true;
            }
            return;
        case 4:
            return false;
        default:
            this.toastr.warning("Escolha um status para Juros e Multa.", "Atenção!");
            return true;
    }
  }

  isContractTypeAndQuoficientInvalid(): boolean {
    if (this.companyInventory.contractType && (!this.companyInventory.contractType._id ||
         this.companyInventory.contractType._id == '')) {
            this.toastr.warning(
                'Escolha um tipo de contrato',
                'Atenção!'
            );
            return true;
    }

    if (!this.companyInventory.readjustmentIndex || (this.companyInventory.readjustmentIndex === 0 ||
         !this.companyInventory.readjustmentIndex)) {
            this.toastr.warning(
                'Escolha um índice de reajuste.', 'Atenção!');
            return true;
        }
    return false;
  }

  isCompanyGroupInvalid(): boolean {
    if (this.dropDownCompanyGroups.selectedItems && this.dropDownCompanyGroups.selectedItems.length == 0) {
            this.toastr.warning(
                'Escolha um grupo de empresa',
                'Atenção!'
            );
            return true;
    }
    return false;
  }

  isCustomerInvalid(): boolean {
    if (this.dropDownCustomer.selectedItems && this.dropDownCustomer.selectedItems.length == 0) {
            this.toastr.warning(
                'Escolha um cliente',
                'Atenção!'
            );
            return true;
    }
    return false;
  }

  async onSave(): Promise<void> {
    if (this.isCompanyGroupInvalid() ||
        this.isCustomerInvalid() ||
        this.isDateFieldsInvalid() ||
        this.isFinesAndInterestInvalid() ||
        this.isContractTypeAndQuoficientInvalid()) {
        return;
    }

    if ((this.selectedFiles && this.selectedFiles.length > 10 || (this.fileList && this.fileList.length > 10))) {
        this.toastr.warning('Não é possível fazer upload com mais de 10 arquivos. Selecione os arquivos novamente.', "Atenção!");
        return;
    }

    let isIndustry= true;
    if ((this.companyInventory.industry && (!this.companyInventory.industry._id || this.companyInventory.industry._id == "undefined"))) {
          isIndustry = false;
    }
    if (!isIndustry) {
        this.toastr.warning("Verifique se o setor foi selecionado.", "Atenção!");
        return;
    }

    let isCenterSelected = true;
    if ((this.companyInventory.excellenceCenterResponsible &&
      (!this.companyInventory.excellenceCenterResponsible._id || this.companyInventory.excellenceCenterResponsible._id == "undefined"))
    ) {
      isCenterSelected = false;
    }
    if (!isCenterSelected) {
        this.toastr.warning("Verifique se o responsável do centro de excelência foi selecionado.", "Atenção!");
        return;
    }

    if (this.companyInventory.excellenceCenter && (this.companyInventory.excellenceCenter._id !== "" || String(this.companyInventory.excellenceCenter._id) == "undefined")) {
        this.companyInventory.excellenceCenter = this.excellenceCenters.find((center) => center._id == this.companyInventory.excellenceCenter._id);
    }

    if (isCenterSelected) {
        const user = this.responsibles.find((user) => user._id == this.companyInventory.excellenceCenterResponsible._id);
        this.companyInventory.excellenceCenterResponsible = user;
    }

    this.companyInventory.companyGroup = {
        _id: this.dropDownCompanyGroups.selectedItems[0].id,
        name: this.dropDownCompanyGroups.selectedItems[0].itemName
    } as CompanyGroup;

    this.companyInventory.customer = {
        _id: this.dropDownCustomer.selectedItems[0].id,
        name: this.dropDownCustomer.selectedItems[0].itemName
    } as Company;


    if (this.dropDownProjectHashtrack.selectedItems && this.dropDownProjectHashtrack.selectedItems.length > 0) {
        this.companyInventory.project = {
            _id: this.dropDownProjectHashtrack.selectedItems[0].id,
            name: this.dropDownProjectHashtrack.selectedItems[0].itemName
        } as ProjectHashtrack;
    }

    if (this.companyInventory.industryResponsible && (String(this.companyInventory.industryResponsible._id) === "undefined" ||
        String(this.companyInventory.industryResponsible._id) !== "" || String(this.companyInventory.industryResponsible._id) != undefined)) {
        const user = this.responsibles.find((user) => user._id == this.companyInventory.industryResponsible._id);
        this.companyInventory.industryResponsible = user;
    }

    if (this.companyInventory.industry && (this.companyInventory.industry._id !== "" || String(this.companyInventory.industry._id) !== "undefined")) {
        this.companyInventory.industry = this.industries.find((industry) => industry._id == this.companyInventory.industry._id) as Industry;
    }

    this.formatDate();
    this.loading = true;
    try {
        const response = await this.companyInventoryService.edit(this.companyInventory);
        if (response._id) {
            this.loading = false;
            this.toastr.success('Inventário editado com sucesso!');
            this.router.navigate(['/companies/company-inventory'])
        }
        this.loading = false;
    } catch (error) {
        this.errorHandler.interceptError(error, 'Inventário');
        this.loading = false;
    }
  }

  OnClear(): void {
    this.companyInventory = new CompanyInventoryModel();
    this.fileInput.nativeElement.value = '';
    this.selectedFiles = undefined;
  }

  getNewContractData(event: any): void {
    this.contractTypes.push(event);
  }

  onNeedReajustmentChange(event: any): void {
    if (event) {
        this.companyInventoryForm.controls['readjustmentDate'].enable();
        this.companyInventory.daysForNotificationOfReadjustment.notApplicable = event;
    } else {
        this.companyInventoryForm.controls['readjustmentDate'].disable();
        this.companyInventory.daysForNotificationOfReadjustment.notApplicable = event;
    }
  }

  onIndefinitePeriodChange(event: any): void {
    this.companyInventory.readjustmentDate.notApplicable = !event;
    this.companyInventory.daysForNotificationOfReadjustment.notApplicable = !event;
    if (event) {
        this.companyInventoryForm.controls['dateEnd'].disable();
        this.companyInventoryForm.controls['readjustmentDate'].disable();
        this.companyInventory.dateEnd.date = undefined;
        this.companyInventory.dateEnd.date = undefined;
        this.companyInventory.closingNotificationDays = 0;
        this.companyInventory.daysForNotificationOfReadjustment.days = 0;
    } else {
        this.companyInventoryForm.controls['dateEnd'].enable();
        this.companyInventoryForm.controls['readjustmentDate'].enable();
    }
  }

  formatDate() {
    if (this.companyInventory.startDate) {
        this.companyInventory.startDate = moment( this.companyInventory.startDate, "DD/MM/YYYY").add(4, 'hours').toString();
    }

    if (this.companyInventory.dateEnd && this.companyInventory.dateEnd.date) {
        this.companyInventory.dateEnd.date = moment( this.companyInventory.dateEnd.date, "DD/MM/YYYY").add(4, 'hours').toString();
    }

    if (this.companyInventory.readjustmentDate && this.companyInventory.readjustmentDate.date) {
        this.companyInventory.readjustmentDate.date = moment( this.companyInventory.readjustmentDate.date, "DD/MM/YYYY").add(4, 'hours').toString();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-inventory/company-inventory-edit/company-inventory.component-edit.ts